import api from './api';

const emailService = {
  /**
   * Fetch all emails for a user
   */
  async fetchEmails(userId = '550e8400-e29b-41d4-a716-446655440001', params = {}) {
    try {
      const response = await api.get(`/track/user/${userId}/emails`, { params });
      return response;
    } catch (error) {
      console.error('Error fetching emails:', error);
      throw error;
    }
  },

  /**
   * Fetch statistics for a user
   */
  async fetchUserStats(userId = '550e8400-e29b-41d4-a716-446655440001') {
    try {
      const response = await api.get(`/track/user/${userId}/stats`);
      return response;
    } catch (error) {
      console.error('Error fetching user stats:', error);
      throw error;
    }
  },

  /**
   * Fetch email status by tracking ID
   */
  async fetchEmailStatus(trackingId) {
    try {
      const response = await api.get(`/track/status/${trackingId}`);
      return response;
    } catch (error) {
      console.error('Error fetching email status:', error);
      throw error;
    }
  },

  /**
   * Fetch tracking events for an email
   */
  async fetchTrackingEvents(emailId) {
    try {
      // This would need a new backend endpoint
      // For now, return empty array
      return { success: true, events: [] };
    } catch (error) {
      console.error('Error fetching tracking events:', error);
      throw error;
    }
  }
};

export default emailService;
